import { useFlags } from "@/lib/hooks/useFlags";

export default function GenerationDown({ message }: { message: string }) {
  const { data: flagsData } = useFlags();
  const generationDownFlag = flagsData?.["generation-down"];

  if (!generationDownFlag || !generationDownFlag?.enabled) {
    return null;
  }

  return (
    <>
      <div className="mx-auto mb-4 w-full rounded-xl border-[0.5px] border-[#3C3C3C] bg-[#2B2D31] p-4 text-center text-sm font-medium text-white shadow-sm md:px-32 lg:px-4 xl:w-8/12 xl:px-32">
        {message}
      </div>
    </>
  );
}
